export default __webpack_public_path__ + "static/O0239-3a668878191c63b026bfb190857b0563.png";